import userData from "@/plugins/userData";
import { FwbAlert } from "flowbite-vue";
import InputSelect from "@/components/InputSelectProfil.vue";
// import { axios } from "@/plugins/axios";
import axios from "axios";
import Highcharts from "highcharts";
// import * as echarts from "echarts";
import { Icon } from "@iconify/vue";
// import moment from "moment";

export default {
  mixins: [userData],
  name: "DashboardPage",
  components: {
    FwbAlert,
    InputSelect,
    Icon,
  },
  data() {
    return {
      mapChart: null,
      districtList: [
        { value: "", text: "Semua Kecamatan" },
        { value: "727101", text: "Palu Timur" },
        { value: "727102", text: "Palu Barat" },
        { value: "727103", text: "Palu Selatan" },
        { value: "727104", text: "Palu Utara" },
        { value: "727105", text: "Ulujadi" },
        { value: "727106", text: "Tatanga" },
        { value: "727107", text: "Tawaeli" },
        { value: "727108", text: "Mantikulore" },
      ],
      filter: {
        district: "",
        year: new Date().getFullYear(),
        month: 1,
      },
      yearList: [],
      monthList: [
        { value: 1, text: "Januari" },
        { value: 2, text: "Februari" },
        { value: 3, text: "Maret" },
        { value: 4, text: "April" },
        { value: 5, text: "Mei" },
        { value: 6, text: "Juni" },
        { value: 7, text: "Juli" },
        { value: 8, text: "Agustus" },
        { value: 9, text: "September" },
        { value: 10, text: "Oktober" },
        { value: 11, text: "November" },
        { value: 12, text: "Desember" },
      ],
      triwulanList: [
        { value: 1, text: "Jan - Maret" },
        { value: 2, text: "April - Juni" },
        { value: 3, text: "Juli - September" },
        { value: 4, text: "Oktober - Desember" },
      ],
      dataMaps: [],
      dataDistrict: [],
      isLoading: true,
      rendered: false,

      // Data untuk setiap modul
      perikananData: {
        total_produksi: {
          mas: 0,
          nila: 0,
          mujair: 0,
          lele: 0,
          vaname: 0,
        },
        total_produksi_kecamatan: [],
      },
      peternakanData: {
        total_ternak: {
          ayam_lokal: 0,
          ayam_ras_pedaging: 0,
          ayam_ras_petelur: 0,
          itik: 0,
          kambing: 0,
          domba: 0,
          sapi_potong: 0,
        },
        total_ternak_kecamatan: [],
      },
      pertanianData: {
        total_data: {
          j_baris: 0,
          j_nik: 0,
          j_rencana_tanam: 0,
          j_urea: 0,
          j_npk: 0,
          j_npk_formula: 0,
          j_organic: 0,
        },
        total_data_kecamatan: [],
      },
      kehamilanData: {
        total_data: 0,
        umur_termuda: 0,
        umur_tertua: 0,
        rata_rata_umur: 0,
        risiko_umur_muda: 0,
        risiko_umur_tua: 0,
        grand_multipara: 0,
        distribusi_umur: [],
      },
      persalinanData: {
        total_persalinan: 0,
        umur_termuda: 0,
        umur_tertua: 0,
        rata_rata_umur: 0,
        bayi_hidup: 0,
        bayi_mati: 0,
        distribusi_umur: [],
      },

      // Role access configuration
      roleAccess: {
        admin: [
          "kesehatan",
          "perhubungan",
          "pertanian",
          "perindag",
          "peternakan",
          "perikanan",
        ],
        kesehatan: ["kesehatan"],
        perhubungan: ["perhubungan"],
        pertanian: ["pertanian"],
        perindag: ["perindag"],
        peternakan: ["peternakan"],
        perikanan: ["perikanan"],
      },
    };
  },
  computed: {
    userLevel() {
      return this.userRole || "guest";
    },
    allowedModules() {
      return this.roleAccess[this.userLevel] || [];
    },
    // Cek apakah user adalah admin
    isAdmin() {
      return this.userLevel === "admin";
    },
    // Cek modul tunggal untuk non-admin
    singleModule() {
      if (this.isAdmin) return null;
      return this.allowedModules[0] || null;
    },
  },
  mounted() {
    this.getYearList();
    this.getDashboard();
  },
  methods: {
    getYearList() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 2025; i <= currentYear; i++) {
        years.push({ value: i, text: i });
      }
      this.yearList = years;
    },

    hasAccessTo(module) {
      return this.allowedModules.includes(module);
    },

    getDashboard() {
      this.isLoading = true;

      // Jika non-admin, langsung load data modul spesifik
      if (!this.isAdmin && this.singleModule) {
        this.loadModuleData(this.singleModule);
        return;
      }

      // Untuk admin, load semua data atau data stunting untuk map
      axios
        .get("/v1/dashboard/stunting", {
          headers: {
            "X-Token": this.userToken,
          },
        })
        .then((response) => {
          this.dataMaps = response.data.stunting_by_district;
          this.dataDistrict = response.data.stunting_by_district;
          this.renderDistrict();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.error = error.message;
        });
    },

    loadModuleData(module) {
      switch (module) {
        case "perikanan":
          this.loadPerikananData();
          break;
        case "peternakan":
          this.loadPeternakanData();
          break;
        case "pertanian":
          this.loadPertanianData();
          break;
        case "kesehatan":
          this.loadKesehatanData();
          break;
        default:
          this.isLoading = false;
      }
    },

    // Load Perikanan Data
    loadPerikananData() {
      axios
        .get("/v1/dashboard/perikanan", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.perikananData.total_produksi = response.data.total_produksi;

          // Load data kecamatan
          return axios.get("/v1/dashboard/perikanan/produksi-kecamatan", {
            headers: {
              "X-Token": this.userToken,
            },
            params: {
              year: this.filter.year,
              month: this.filter.month,
            },
          });
        })
        .then((response) => {
          this.perikananData.total_produksi_kecamatan =
            response.data.produksi_kecamatan;
          this.isLoading = false;
          this.$nextTick(() => {
            this.renderProduksiPerikananKecamatan();
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    // Load Peternakan Data
    loadPeternakanData() {
      axios
        .get("/v1/dashboard/peternakan", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.peternakanData.total_ternak = response.data.total_ternak;

          // Load data kecamatan
          return axios.get("/v1/dashboard/peternakan/produksi-kecamatan", {
            headers: {
              "X-Token": this.userToken,
            },
            params: {
              year: this.filter.year,
              month: this.filter.month,
            },
          });
        })
        .then((response) => {
          this.peternakanData.total_ternak_kecamatan =
            response.data.produksi_kecamatan;
          this.isLoading = false;
          this.$nextTick(() => {
            this.renderProduksiPeternakanKecamatan();
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    // Load Pertanian Data
    loadPertanianData() {
      axios
        .get("/v1/dashboard/pertanian", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.pertanianData.total_data = response.data.total_data;

          // Load data kecamatan
          return axios.get("/v1/dashboard/pertanian/produksi-kecamatan", {
            headers: {
              "X-Token": this.userToken,
            },
            params: {
              year: this.filter.year,
              month: this.filter.month,
            },
          });
        })
        .then((response) => {
          this.pertanianData.total_data_kecamatan =
            response.data.produksi_kecamatan;
          this.isLoading = false;
          this.$nextTick(() => {
            this.renderProduksiPertanianKecamatan();
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    // Load Kesehatan Data (Kehamilan & Persalinan)
    loadKesehatanData() {
      Promise.all([
        axios.get("/v1/dashboard/ibu-hamil", {
          headers: { "X-Token": this.userToken },
          params: { year: this.filter.year, month: this.filter.month },
        }),
        axios.get("/v1/dashboard/ibu-hamil/distribusi-umur", {
          headers: { "X-Token": this.userToken },
          params: { year: this.filter.year, month: this.filter.month },
        }),
        axios.get("/v1/dashboard/ibu-bersalin", {
          headers: { "X-Token": this.userToken },
          params: { year: this.filter.year, month: this.filter.month },
        }),
        axios.get("/v1/dashboard/ibu-bersalin/distribusi-umur", {
          headers: { "X-Token": this.userToken },
          params: { year: this.filter.year, month: this.filter.month },
        }),
        axios.get("/v1/dashboard/stunting", {
          headers: { "X-Token": this.userToken },
        }),
      ])
        .then(
          ([
            kehamilanRes,
            kehamilanDistribusiRes,
            persalinanRes,
            persalinanDistribusiRes,
            stuntingRes,
          ]) => {
            // Kehamilan
            this.kehamilanData = {
              ...kehamilanRes.data.data,
              distribusi_umur: kehamilanDistribusiRes.data.data,
            };

            // Persalinan
            this.persalinanData = {
              ...persalinanRes.data.data,
              distribusi_umur: persalinanDistribusiRes.data.data,
            };

            // Stunting
            this.dataMaps = stuntingRes.data.stunting_by_district;
            this.dataDistrict = stuntingRes.data.stunting_by_district;

            this.isLoading = false;
            this.$nextTick(() => {
              this.renderDistribusiUmurKehamilan();
              this.renderDistribusiUmurPersalinan();
              this.renderDistrict();
            });
          }
        )
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    // Render Charts - Perikanan
    renderProduksiPerikananKecamatan() {
      if (!this.$refs.barProduksiPerikananKecamatan) return;

      Highcharts.chart(this.$refs.barProduksiPerikananKecamatan, {
        chart: { type: "column" },
        credits: { enabled: false },
        title: { text: "Total Produksi Perikanan Berdasarkan Kecamatan" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Jumlah" } },
        legend: { enabled: true },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
        },
        series: [
          {
            name: "Ikan Mas",
            data: this.perikananData.total_produksi_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.mas,
            })),
            color: "#1815e9ff",
          },
          {
            name: "Ikan Nila",
            data: this.perikananData.total_produksi_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.nila,
            })),
            color: "#FE8E00",
          },
          {
            name: "Ikan Mujair",
            data: this.perikananData.total_produksi_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.mujair,
            })),
            color: "#81af04ff",
          },
          {
            name: "Ikan Lele",
            data: this.perikananData.total_produksi_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.lele,
            })),
            color: "#fdd007ff",
          },
          {
            name: "Udang Vaname",
            data: this.perikananData.total_produksi_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.vaname,
            })),
            color: "#0be2d0ff",
          },
        ],
      });
    },

    // Render Charts - Peternakan
    renderProduksiPeternakanKecamatan() {
      if (!this.$refs.barProduksiPeternakanKecamatan) return;

      Highcharts.chart(this.$refs.barProduksiPeternakanKecamatan, {
        chart: { type: "column" },
        credits: { enabled: false },
        title: { text: "Total Usaha Peternakan Berdasarkan Kecamatan" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Jumlah" } },
        legend: { enabled: true },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
        },
        series: [
          {
            name: "Ayam Lokal",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.ayam_lokal,
            })),
            color: "#e44c4cff",
          },
          {
            name: "Ayam Ras Pedaging",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.ayam_ras_pedaging,
            })),
            color: "#ec8f14ff",
          },
          {
            name: "Ayam Ras Petelur",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.ayam_ras_petelur,
            })),
            color: "#9dca20ff",
          },
          {
            name: "Itik",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.itik,
            })),
            color: "#fdd007ff",
          },
          {
            name: "Kambing",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.kambing,
            })),
            color: "#0be2d0ff",
          },
          {
            name: "Domba",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.domba,
            })),
            color: "#f358a0ff",
          },
          {
            name: "Sapi Potong",
            data: this.peternakanData.total_ternak_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.sapi_potong,
            })),
            color: "#7660f3ff",
          },
        ],
      });
    },

    // Render Charts - Pertanian
    renderProduksiPertanianKecamatan() {
      if (!this.$refs.barProduksiPertanianKecamatan) return;

      Highcharts.chart(this.$refs.barProduksiPertanianKecamatan, {
        chart: { type: "column" },
        credits: { enabled: false },
        title: { text: "RDKK Berdasarkan Kecamatan" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Jumlah" } },
        legend: { enabled: true },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
        },
        series: [
          {
            name: "Jumlah Baris",
            data: this.pertanianData.total_data_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.j_baris,
            })),
            color: "#e44c4cff",
          },
          {
            name: "Jumlah NIK",
            data: this.pertanianData.total_data_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.j_nik,
            })),
            color: "#ec8f14ff",
          },
          {
            name: "Rencana Tanam",
            data: this.pertanianData.total_data_kecamatan.map((data) => ({
              name: data.nama_kec,
              y: data.j_rencana_tanam,
            })),
            color: "#9dca20ff",
          },
        ],
      });
    },

    // Render Charts - Kesehatan (Kehamilan)
    renderDistribusiUmurKehamilan() {
      if (!this.$refs.barDistribusiUmurKehamilan) return;

      const colors = ["#7cb5ec", "#e4d354", "#f15c80"];
      Highcharts.chart(this.$refs.barDistribusiUmurKehamilan, {
        chart: { type: "column" },
        credits: { enabled: false },
        title: { text: "Grafik Distribusi Umur Ibu Hamil" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Jumlah" } },
        series: [
          {
            name: "Distribusi Umur",
            data: this.kehamilanData.distribusi_umur.map((data, index) => ({
              name: data.kategori_umur,
              y: data.jumlah,
              color: colors[index % colors.length],
            })),
          },
        ],
      });
    },

    // Render Charts - Kesehatan (Persalinan)
    renderDistribusiUmurPersalinan() {
      if (!this.$refs.barDistribusiUmurPersalinan) return;

      const colors = ["#7cb5ec", "#e4d354", "#f15c80", "#90ed7d", "#8085e9"];
      Highcharts.chart(this.$refs.barDistribusiUmurPersalinan, {
        chart: { type: "column" },
        credits: { enabled: false },
        title: { text: "Grafik Distribusi Umur Ibu Bersalin" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Jumlah" } },
        series: [
          {
            name: "Distribusi Umur",
            data: this.persalinanData.distribusi_umur.map((data, index) => ({
              name: data.kategori_umur,
              y: data.jumlah,
              color: colors[index % colors.length],
            })),
          },
        ],
      });
    },

    renderDistrict() {
      if (!this.$refs.barKecamatan) return;

      Highcharts.chart(this.$refs.barKecamatan, {
        chart: { type: "bar" },
        credits: { enabled: false },
        title: { text: "Data Stunting per Kecamatan" },
        xAxis: { type: "category" },
        yAxis: {
          title: { text: "Jumlah" },
          allowDecimals: false,
        },
        legend: { enabled: false },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: { valueSuffix: " Kasus" },
        series: [
          {
            name: "Jumlah",
            data: this.dataDistrict.map((data) => ({
              name: data.name,
              y: parseInt(data.value),
            })),
            colorByPoint: true,
          },
        ],
      });
    },

    refreshData() {
      this.isLoading = true;
      this.getDashboard();
    },

    numberFormat(value) {
      if (!value) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
